module.exports = __webpack_public_path__ + "static/img/icon-flashsale-4.1cbb465.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/salepage/icon-flashsale-4.png
// module id = xWSs
// module chunks = 134